import React, { useState } from 'react';
import {
  Box,
  Typography,
  Grid,
  Sheet
} from '@mui/joy';
import PrecisionManufacturingIcon from '@mui/icons-material/PrecisionManufacturing';
import MapIcon from '@mui/icons-material/Map';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import PageLayout from '../components/PageLayout';

import CADStandardsAssistant from './GPT/CAD_standards';
import GISLayerAssistant from './GPT/GIS_layers';

const GPT = () => {
  const [activePanel, setActivePanel] = useState(null);

  return (
    <PageLayout title="FLD&P Assistants" fullWidth>
      <Box sx={{ mt: 3, mb: 3, px: 3, width: '75vw', ml: '-24px', pr: 0 }}>
        <Grid container spacing={2}>
          {[
            {
              title: 'CAD Standards Assistant',
              icon: <PrecisionManufacturingIcon />,
              component: <CADStandardsAssistant />
            },
            {
              title: 'GIS Layer Tool',
              icon: <MapIcon />,
              component: <GISLayerAssistant />
            },
            {
              title: 'Coming Soon…',
              icon: <HourglassEmptyIcon />,
              component: <Box />
            }
          ].map(({ title, icon }) => (
            <Grid xs={12} sm={6} md={4} key={title} sx={{ display: 'flex' }}>
              <Sheet
                variant="outlined"
                sx={{
                  flexGrow: 1,
                  p: 3,
                  textAlign: 'center',
                  borderRadius: 'md',
                  cursor: 'pointer',
                  '&:hover': { boxShadow: 'md', borderColor: '#00A884' }
                }}
                onClick={() => setActivePanel(title)}
              >
                {React.cloneElement(icon, { sx: { fontSize: 40, color: '#00A884' } })}
                <Typography level="title-lg" mt={1}>{title}</Typography>
              </Sheet>
            </Grid>
          ))}
        </Grid>
        <Box sx={{ mt: 4 }}>
          {[
            {
              title: 'CAD Standards Assistant',
              component: <CADStandardsAssistant />
            },
            {
              title: 'GIS Layer Tool',
              component: <GISLayerAssistant />
            },
            {
              title: 'Coming Soon…',
              component: <Box />
            }
          ].map(({ title, component }) => activePanel === title && (
            <Box key={title}>{component}</Box>
          ))}
        </Box>
      </Box>
    </PageLayout>
  );
};

export default GPT;